export const ringPct = (items) => {
  const req = items.filter((i) => i.requirement);
  return req.length ? Math.round((100 * req.filter((i) => i.completed).length) / req.length) : null;
};

export const ProgressRing = ({ pct, size = 44, stroke = 5, testId }) => {
  const r = (size - stroke) / 2, c = 2 * Math.PI * r, p = pct ?? 0;
  const color = p >= 100 ? "#2E7D4F" : p > 0 ? "#C87D53" : "#D6CDB4";
  return (
    <span className="relative inline-grid place-items-center shrink-0" style={{ width: size, height: size }} data-testid={testId} aria-label={pct == null ? "No progress tracked" : `${p}% done`}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#EEE8DA" strokeWidth={stroke} />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth={stroke} strokeLinecap="round" strokeDasharray={c} strokeDashoffset={c - (c * p) / 100} style={{ transition: "stroke-dashoffset 600ms ease" }} />
      </svg>
      <span className={`absolute font-semibold text-[#2C4A3E] ${size >= 40 ? "text-[11px]" : "text-[8px]"}`}>{pct == null ? "–" : `${p}%`}</span>
    </span>
  );
};
